import { render, staticRenderFns } from "./ProjectThumbnail.vue?vue&type=template&id=2e8a04cb&scoped=true"
import script from "./ProjectThumbnail.vue?vue&type=script&lang=ts"
export * from "./ProjectThumbnail.vue?vue&type=script&lang=ts"
import style0 from "./ProjectThumbnail.vue?vue&type=style&index=0&id=2e8a04cb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8a04cb",
  null
  
)

export default component.exports